// document.addEventListener('click', (elm) => {
//     let addToBagBtn = elm.target.closest('.ctm_cart_content');

//     if(addToBagBtn){
        
//         let item = elm.target;
//         const productId = item.getAttribute('data-id');

//         console.log(productId);

//         fetch('/cart/add.js', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'X-Requested-With': 'XMLHttpRequest',
//             },
//             body: JSON.stringify({
//                 items: [{
//                     id: productId,
//                     quantity: 1
//                 }]
//             })
//         })
//         .then(response => response.json())
//         .then(data => {
//             $('.previewCart-wrapper').load(location.href + " .previewCart-wrapper");
//             console.log('Product added to cart:', data);

//         })
//         .catch(error => {
//             console.error('Error adding product to cart:', error);
//         });

//     }

// })
  

const updateMainCart = async (cart) => {
  try {
    const sectionId = document.querySelector('#main-cart-items').getAttribute('data-id');

    const cartElement = document.querySelector('[data-cart]');
    const cartContent = cartElement.querySelector('[data-cart-content]');
    const cartTotals = cartElement.querySelector('[data-cart-total]');

    const cartLoading = `
    <div class="loading-overlay loading-overlay--custom">
      <div class="loading-overlay__spinner">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    </div>`;

    const loadingClass = 'is-loading';

    cartElement.classList.add(loadingClass);
    cartElement.insertAdjacentHTML('afterbegin', cartLoading);

    const response = await fetch(`/cart?section_id=${sectionId}`);
    const data = await response.text();

    const jsPreventedData = data.replaceAll('cart-coupon-discount', 'div');
    const parsedResponse = new DOMParser().parseFromString(jsPreventedData, 'text/html');

    cartElement.classList.remove(loadingClass);
    cartElement.querySelector('.loading-overlay').remove();

    if (cart.item_count > 0) {
      const contentCart = parsedResponse.querySelector('[data-cart-content] .cart').innerHTML;
      const subTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-subtotal').innerHTML;
      const grandTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-grandtotal').innerHTML;
      const savings = parsedResponse.querySelector('[data-cart-total] .cart-total-savings').innerHTML;

      cartContent.querySelector('.cart').innerHTML = contentCart;
      cartTotals.querySelector('.cart-total-subtotal').innerHTML = subTotal;
      cartTotals.querySelector('.cart-total-grandtotal').innerHTML = grandTotal;
      cartTotals.querySelector('.cart-total-savings').innerHTML = savings;

      const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
      if (calculatorShipping) {
        const existingCalculator = cartElement.querySelector('.haloCalculatorShipping');
        if (existingCalculator) {
          existingCalculator.replaceWith(calculatorShipping);
        }
      }

      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

      document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
        const changeEvent = new Event('change', { bubbles: true })
        freeShippingWrapper.dispatchEvent(changeEvent);
      })
    } else {
      const contentCart = parsedResponse.querySelector('#main-cart-items').innerHTML;
      const headerCart = parsedResponse.querySelector('.page-header').innerHTML;

      document.querySelector('#main-cart-items').innerHTML = contentCart;
      document.querySelector('.page-header').innerHTML = headerCart;

      document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
        const changeEvent = new Event('change', { bubbles: true })
        freeShippingWrapper.dispatchEvent(changeEvent);
      })
    }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
};

async function updateSideCart(cart) {
    try {
      const cartElement = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
      const cartContent = cartElement.querySelector('.previewCartList');
      const cartTotals = cartElement.querySelector('.previewCartTotalsPrice');

      const cartLoading = `
      <div class="loading-overlay loading-overlay--custom">
        <div class="loading-overlay__spinner">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </div>`;

      const loadingClass = 'is-loading';

      cartElement.classList.add(loadingClass);
      cartElement.insertAdjacentHTML('afterbegin', cartLoading);

      const response = await fetch(`/cart?view=ajax_side_cart`);
      const data = await response.text();
      const parsedResponse = new DOMParser().parseFromString(data, 'text/html');

      cartElement.classList.remove(loadingClass);
      cartElement.querySelector('.loading-overlay').remove();      

      if (cart.item_count > 0) {        
        const contentCart = parsedResponse.querySelector('.previewCartList').innerHTML;        
        const contentTotals = parsedResponse.querySelector('.previewCartTotalsPrice').innerHTML;

        cartContent.innerHTML = contentCart;
        cartTotals.innerHTML = contentTotals;

        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

        const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
        if (calculatorShipping) {
          const existingCalculator = cartElement.querySelector('.haloCalculatorShipping');
          if (existingCalculator) {
            existingCalculator.replaceWith(calculatorShipping);
          }
        }

        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
          const changeEvent = new Event('change', { bubbles: true })
          freeShippingWrapper.dispatchEvent(changeEvent);
        })
      }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

//////////// CART UPSELL NEW //////////// 
document.addEventListener('click',async (elm) => {
  let addToBagBtn = elm.target.closest('.add_to_bag');
  if (addToBagBtn) {
    const productId = addToBagBtn.getAttribute('data-id');  

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: productId,
          quantity: 1
        }]
      })
    });

    const data = await response.json();

    Shopify.getCart(async (cart) => {
      if (document.querySelector(".template-cart")) {
        await updateMainCart(cart); 
      } else {
        await updateSideCart(cart);
      }
    });
  }
});
// Listen for the custom event to re-initialize the slick slider
// document.documentElement.addEventListener('cart:refresh', function () {
//     // Re-initialize your slick slider here
//     $('.ctm_cart_unsell').slick({
//         infinite: true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: false,
//         prevArrow: '<button type="button" class="slick-prev custom_slick_prev"><img src="https://cdn.shopify.com/s/files/1/2330/4667/files/left-arrow_2.png?v=1718100689" alt="Previous" /></button>',
//         nextArrow: '<button type="button" class="slick-next custom_slick_next"><img src="https://cdn.shopify.com/s/files/1/2330/4667/files/right-arrow_4_51a5f9c7-2b14-4040-b6ed-d168dd615242.png?v=1718099941" alt="Next" /></button>'
//     });
// });

document.addEventListener("DOMContentLoaded", function () {

function Collectionhover() {
    if (window.matchMedia("(min-width:1px)").matches){
      const hoverItems = document.querySelectorAll('.collection_hover_items');

    function removeAllActiveHover() {
        hoverItems.forEach(function (elem) {
            elem.classList.remove('active_hover');
        });
    }

    if (hoverItems.length > 0) {
        hoverItems[0].classList.add('active_hover');
    }

    hoverItems?.forEach(function (currElem) {
        currElem.addEventListener('mouseover', function () {
            removeAllActiveHover();
            currElem.classList.add('active_hover');
        });

        
    });
}

if (window.matchMedia("(max-width:1366px)").matches){
    // Assuming you have elements with class 'collection_hover_items'
    const items = document.querySelectorAll('.collection_hover_items');
    
    // Function to handle click events
    function handleClick(event) {
        const clickedItem = event.target.closest('.collection_hover_items');
    
        if (!clickedItem) return; // Exit if the click isn't on a relevant element
    
        // Remove 'hover_active' class from all items
        items.forEach(item => item.classList.remove('hover_active'));
    
        // Add 'hover_active' class to the clicked item
        clickedItem.classList.add('hover_active');
    }
    
    // Attach click event listener to a common parent element (e.g., document or specific container)
    document.addEventListener('click', handleClick);

    // Add 'hover_active' class to the first item by default
    if (items.length > 0) {
        items[0].classList.add('hover_active');
    }
}



if (window.matchMedia("(min-width:768px)").matches) {
  // Select the element with the class 'coll_hover_text_inner' inside .active_hover
  var innerElement = document.querySelector('.hover_active .coll_hover_text_inner');

  // Select the parent elements where you want to apply the height adjustment
  var parentElements = document.querySelectorAll('.collection_hover_items');

  // Check if innerElement exists
  if (innerElement) {
    // Function to calculate the total height including margins, padding, and whitespace
    function calculateTotalHeight(element) {
      var style = window.getComputedStyle(element);
      var margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
      var padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
      var totalHeight = element.offsetHeight + margin + padding;
      return totalHeight;
    }

    // Loop through each parent element and apply the height adjustment
    parentElements.forEach(function(parentElement) {
      // Calculate the total height including margins, padding, and whitespace
      var totalHeight = calculateTotalHeight(innerElement) + 60; // Adding 60 pixels

      // Ensure the height is at least 520 pixels
      if (totalHeight < 520) {
        totalHeight = 520;
      }

      // Apply the height to the parent element
      parentElement.style.height = totalHeight + 'px';

      console.log('Applied total height to .collection_hover_items:', totalHeight);
    });
  } else {
    console.log('Inner element not found.');
  }
}


function calculateTotalHeight(element) {
  var height = element.offsetHeight;
  var style = window.getComputedStyle(element);

  // Calculate total height including margins, padding, and border
  height += parseInt(style.marginTop) + parseInt(style.marginBottom);
  height += parseInt(style.paddingTop) + parseInt(style.paddingBottom);
  height += parseInt(style.borderTopWidth) + parseInt(style.borderBottomWidth);

  return height;
}
}


Collectionhover();
  document.addEventListener('resize', Collectionhover)

  
// // Assuming you have a div with id 'targetDiv' that you want to scroll to
// const targetDiv = document.querySelector('.hover_active'); // Use querySelector if targeting a single element

// // Function to handle smooth scrolling
// function scrollToTarget() {
//     targetDiv.scrollIntoView({ behavior: 'smooth' });
// }

// // Assuming you have a button or any clickable element that triggers the scroll
// const scrollButtons = document.querySelectorAll('.collection_hover_items'); // NodeList of elements

// // Adding click event listener to each button
// scrollButtons.forEach(button => {
//     button.addEventListener('click', scrollToTarget);
// });







    //   ===========  Custom Hover Section ============



    // let links = document.querySelectorAll('.collection_hover_items');
    // let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    // let blockedClass = 'blocked-click';

    // links.forEach(function(link) {
    //     let clickCount = 0;

    //     link.addEventListener('click', function(event) {
    //         if (isMobile) {
    //             clickCount++;
    //             if (clickCount === 1) {
    //                 event.preventDefault();
    //                 link.classList.add(blockedClass);
                    
    //                 setTimeout(function() {
    //                     link.classList.remove(blockedClass);
    //                 }, 1000); 
    //             } else {
    //                 clickCount = 0;
    //                 window.location.href = link.href; 
    //             }
    //         }
    //     });
    // });


// =============== Video play pause ================

document.querySelectorAll('.video_item').forEach(function(currVideo) {
        const videoElem = currVideo.querySelector('.ctm_vedio_pay_pause');
        const playButton = currVideo.querySelector('#video_play_button');
        const pauseButton = currVideo.querySelector('#video_pause_button');

        pauseButton.style.display = 'none';

        currVideo.querySelector('.ctm_video_buttons').addEventListener("click", function(event) {

            if (event.target.closest('#video_play_button') === playButton) {
                videoElem.play();
                playButton.style.display = 'none';
                pauseButton.style.display = 'inline-flex';
            } else if (event.target.closest('#video_pause_button') === pauseButton) {
                videoElem.pause();
                pauseButton.style.display = 'none';
                playButton.style.display = 'inline-flex';
            }
        });

        videoElem.addEventListener('ended', function() {
            playButton.style.display = 'inline-flex';
            pauseButton.style.display = 'none';
        });
    });





//================ Video section Initialize Swiper=============
new Swiper('.swiper', {
    loop: true,
    grabCursor: true,
    slidesPerView: 5,
    paginationClickable: true,
    spaceBetween: 20,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    // Responsive breakpoints
    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: "auto",
          spaceBetween: 10,
          centeredSlides: false
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        // when window width is >= 640px
        1240: {
          slidesPerView: 5,
          spaceBetween: 20
        }
      }
});
document.querySelectorAll("[data-btn-addtocart]")?.forEach(function (curElm) {
        curElm.addEventListener("click",function(e){
            e.preventDefault();
            document.body.classList.add("cart-sidebar-show");
            // document.querySelector("body.cart-sidebar-show #halo-cart-sidebar .halo-sidebar-header").style.opacity = "0";
        const $cartDropdown = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
        const $cartLoading = '<div class="loading-overlay loading-overlay--custom">\
                <div class="loading-overlay__spinner">\
                    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                    </svg>\
                </div>\
            </div>';
        const loadingClass = 'is-loading';
        $cartDropdown
            .addClass(loadingClass)
            .prepend($cartLoading);
       const closestHeader = document.querySelector(".previewCart-wrapper").closest("#halo-cart-sidebar");
       const isLoadingDiv = document.querySelector(".previewCart-wrapper");
        // if (closestHeader) {
        //     const sidebarHeader = closestHeader.querySelector(".halo-sidebar-header");
        //     if (isLoadingDiv.classList.contains("is-loading")) {
        //         sidebarHeader.style.opacity = "0";
        //     } else {
        //         sidebarHeader.style.opacity = "1";
        //     }
        // }
        document.querySelector("[data-shipping-message]").innerHTML = "";
        document.querySelector("[data-cart-count]").innerHTML = "";
        })
    })
});


document.addEventListener("DOMContentLoaded", function() {
    const nodes = document.querySelectorAll('.animating_node');
    let currentIndex = 0;

    function showNextNode() {
        nodes[currentIndex].classList.remove('active');
        currentIndex = (currentIndex + 1) % nodes.length;
        nodes[currentIndex].classList.add('active');
    }

    function startAnimation() {
        nodes[currentIndex].classList.add('active');
        setInterval(showNextNode, 2000); // Change every 2 seconds
    }

    startAnimation();

    ///////////////////// Custom Setup for Selling Plan /////////////////////

    // const subbifyInterval = () => {
    //     setInterval(() => {
    //         const choiceBoxes = document.querySelectorAll('.subify-choice-box-wrapper');
    //         choiceBoxes.forEach(choiceBox => {
    //             if (!choiceBox.querySelector('.subify-selling-plan-whole-wrapper')) {
    //                 choiceBox.classList.add('no-selling-plan');
    //             }
    //         });
    //         if (choiceBoxes.length > 0) clearInterval(subbifyInterval);            
    //     }, 100);
    // }

    // subbifyInterval();

    let actualPriceInner = document.querySelector(".ctm_price_enable .custom_price").innerHTML;

    document.querySelector(".productView-buttons")?.addEventListener("click", function(evt) {
        const activeBox = evt.target.closest(".subify-choice-box-wrapper.active");
        const noSellingPlanBox = evt.target.closest(".subify-choice-box-wrapper:nth-child(1)"); 

        if (activeBox && !noSellingPlanBox) {
            const subifyChoicePrice = activeBox?.querySelector(".subify-choice-price")?.innerHTML;
            const newPrice = document.querySelector(".ctm_price_enable .custom_price");
            newPrice.innerHTML = `${subifyChoicePrice}`;
        }

        if (noSellingPlanBox) {
            const newPrice = document.querySelector(".ctm_price_enable .custom_price");
            newPrice.innerHTML = actualPriceInner;
        }
    });

    ///////////////////// End Of Subify //////////////////

     const videos = document.querySelectorAll("video.text_with_video");

      const handleVideoPlayback = (entries) => {
          entries.forEach((entry) => {
          if (entry.isIntersecting) {
              entry.target.play();
          } else {
              entry.target.pause();
          }
          });
      };
  
      const observer = new IntersectionObserver(handleVideoPlayback, {
          threshold: 0.5, 
      });
  
      videos?.forEach((video) => {
          observer.observe(video);
      });
});

window.onload = function () {
  const stickyAddToCart = document.querySelector('sticky-add-to-cart');
  if (stickyAddToCart) {
    stickyAddToCart.style.display = 'block';
  }
};

if (window.location.href.includes("shipping-insurance-skip-the-line")) {
  window.location.href = "/collections/ALL";  
}


 document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.jump_list_item').forEach((item) => {
      item.addEventListener('click', function (event) {
        event.preventDefault();
        const targetId = item.getAttribute('href');
        if (targetId && targetId.startsWith('#')) {
          const targetSection = document.querySelector(targetId);
          if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });

     let attempts = 0, maxAttempts = 50;
     const interval = setInterval(() => {
      const el = document.querySelector('.subify-widget-box .subify-choice-box-wrapper.active');
      if (el) {
        el.click();
        clearInterval(interval);
      }
      if (++attempts >= maxAttempts) clearInterval(interval);
    }, 200);
   
  });





